import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
// metrics
import {metrics} from '~/vendor/metrics';
import withRouter, {routerPropTypes} from '~/router/withRouter';
import {Button, Link} from '@customink/pigment-react';
import {getCheckoutSummaryLink} from '../../constants/CheckoutLink';

const propTypes = {
  dismiss: PropTypes.func,
  exitWarningEligibility: PropTypes.func,
  router: routerPropTypes,
  onMounted: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
class ShoppingCartConfirmDirtyNotification extends Component {
  static propTypes = propTypes;

  static defaultProps = {
    dismiss() {},
    primaryAction() {},
    exitWarningEligibility() {}
  };

  componentDidMount() {
    metrics.pageViewTag('/ndx/cart/designdirty');
    this.updateExitWarningEligibility(false);
  }

  componentWillUnmount() {
    this.updateExitWarningEligibility();
  }

  cancel = () => {
    metrics.fireEvent('multi item modal', 'cart overlay', 'continue to cart');
    window.location.href = getCheckoutSummaryLink();
  };

  close = () => {
    metrics.fireEvent('multi item modal', 'cart overlay', 'return to lab');
    this.props.dismiss();
  };

  confirm = () => {
    metrics.fireEvent('multi item modal', 'cart overlay', 'save form');
    this.props.dismiss();
    this.props.router.navigate('/next/saveForm?src=cartSavePrompt');
  };

  updateExitWarningEligibility = (eligible = true) => {
    this.props.exitWarningEligibility(eligible);
  };

  render() {
    return (
      <Notification dismiss={this.close} title="Save Design?" type="ERROR">
        <p className="ndx-cta1">
          You will lose any unsaved changes by continuing to your cart.
        </p>
        <Button
          size="large"
          variant="Primary"
          className="notification-cta"
          onClick={this.confirm}>
          Save for Later
        </Button>
        <br />
        <span className="notication-Linkspan">Or,&nbsp;</span>
        <Link className="ndx-cta-Link" button onClick={this.cancel}>
          continue without saving
        </Link>
      </Notification>
    );
  }
}

ShoppingCartConfirmDirtyNotification.displayName =
  'ShoppingCartConfirmDirtyNotification';

export default withRouter(ShoppingCartConfirmDirtyNotification);
